export const ENTITY_TO_TAB: Record<string, { path: string; labelKey: string }> =
  {
    muscle: { path: '/muscles', labelKey: 'adminDashboard.sync.muscles' },
    exercise: { path: '/exercises', labelKey: 'adminDashboard.sync.exercises' },
  };
